import { render, staticRenderFns } from "./GlobalMessageBox.vue?vue&type=template&id=63542e93&"
import script from "./GlobalMessageBox.js?vue&type=script&lang=js&"
export * from "./GlobalMessageBox.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/develop.mijnmooiestraat.vlaanderen/pro-develop.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63542e93')) {
      api.createRecord('63542e93', component.options)
    } else {
      api.reload('63542e93', component.options)
    }
    module.hot.accept("./GlobalMessageBox.vue?vue&type=template&id=63542e93&", function () {
      api.rerender('63542e93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/GlobalMessageBox/GlobalMessageBox.vue"
export default component.exports